import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[shared-title-if-ellipse]',
  standalone: false,
})
export class TitleIfEllipseDirective {
  @HostListener('mouseover', ['$event.target'])
  onMouseOver(element: HTMLElement): void {
    element.title = element.scrollWidth > element.clientWidth ? element.textContent : '';
  }
}
